module.exports = __webpack_public_path__ + "img/gongye.b703ee7a.jpg";